import { Injectable } from '@angular/core';
import { JobsService } from './jobs-service';
import { Company } from '@ups/xplat/api/dto';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchCompanyService {
  constructor(private jobsService: JobsService) {}

  search(
    searchString: string | null,
    activeOnly = false,
    keepCompanyNumber: number | string | null = null
  ): Observable<Company[]> {
    return from(
      this.jobsService.getCompanies(false).then((data: Company[]) => {
        const byName = this._filterByName(searchString, data);
        if (!activeOnly) {
          return byName;
        }
        // activeOnly is opt-in per usage (e.g. SRF) and constrains only NEW picks: keep
        // known-active companies PLUS the currently-selected company (keepCompanyNumber)
        // even if it has since gone inactive, so an existing record still renders its saved
        // company and stays saveable. IsActive is projected server-side from
        // bHQCO.udActiveYN === 'Y'.
        const keep =
          keepCompanyNumber != null ? keepCompanyNumber.toString() : null;
        return byName.filter(
          (c) =>
            c?.IsActive === true ||
            (keep != null && c?.CompanyNumber?.toString() === keep)
        );
      })
    );
  }

  private _filterByName(
    searchString: string | null,
    data: Company[]
  ): Company[] {
    // make sure the search string is a string before doing toLowerCase
    const names = (searchString || '')
      .toString()
      .toLowerCase()
      .split(',')
      .filter((v) => !!v);
    return (data || []).filter((c) => {
      if (names.length && c) {
        return c.CompanyName
          ? names.includes((<string>c.CompanyName).toLowerCase()) ||
              names.includes(c.CompanyNumber.toString())
          : false;
      } else {
        return true;
      }
    });
  }
}
